export const SHOP_TO_CLUB_FOOTER_LINK = 'shop_to_club_banner_mobile';
export default { SHOP_TO_CLUB_FOOTER_LINK };
